import { render } from "./RequestInitiativeTtrCardAdd.vue?vue&type=template&id=619f67e5"
import script from "./RequestInitiativeTtrCardAdd.vue?vue&type=script&lang=js"
export * from "./RequestInitiativeTtrCardAdd.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__